import type { KickDto, MatchStateDto, SideDto } from '@penalty-cup/shared';
import { Jersey } from './Jersey.js';

const REGULATION = 5;

function Dots({ kicks, side }: { kicks: KickDto[]; side: SideDto }) {
  const own = kicks.filter((k) => k.shooter === side);
  const slots = Math.max(REGULATION, own.length);
  return (
    <span className="score__dots">
      {Array.from({ length: slots }, (_, i) => {
        const k = own[i];
        const cls = !k ? '' : k.outcome === 'GOAL' ? 'score__dot--goal' : 'score__dot--miss';
        return <i key={i} className={`score__dot ${cls}`} />;
      })}
    </span>
  );
}

export function Scoreboard({ match, label }: { match: MatchStateDto; label: string }) {
  const [a, b] = match.players;
  const you = match.you;
  return (
    <header className="score">
      <div className={`score__side ${you === 'A' ? 'score__side--you' : ''}`}>
        <span className="score__name">
          <Jersey kit={a.kit} className="score__kit" />
          {a.name}
        </span>
        <Dots kicks={match.kicks} side="A" />
      </div>
      <div className="score__center">
        <span className="score__value">
          {match.score.A}
          <span className="score__colon">:</span>
          {match.score.B}
        </span>
        <span className="score__label">{label}</span>
      </div>
      <div className={`score__side score__side--right ${you === 'B' ? 'score__side--you' : ''}`}>
        <span className="score__name">
          {b.name}
          <Jersey kit={b.kit} className="score__kit" />
        </span>
        <Dots kicks={match.kicks} side="B" />
      </div>
    </header>
  );
}
